import { createContext, useState } from "react";

export const WhatsAppSessoesContext = createContext();

export const WhatsAppSessoesProvider = ({ children }) => {
    const [sessoes, setSessoes] = useState([]);
    const [loading, setLoading] = useState(false);

    return (
        <WhatsAppSessoesContext.Provider value={{
            sessoes, setSessoes,
            loading, setLoading
        }}>
            {children}
        </WhatsAppSessoesContext.Provider>
    );
};
